import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockReputationDeveloper');

@I18nHoc(translates())
export default class ReputationDeveloperBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { i18n } = this;
    const { className } = this.props;

    return (
      <div {...classes({ extra: className })}>
          <Row {...classes('row', 'block')} allColumn>
            <Col {...classes('col', 'info')} allPr={0}>
              <div {...classes('text', 'h2')}><h2 children={i18n('reputationDeveloperH2')} /></div>
              <Trans lang="ru">
                <ul {...classes('list')}>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="В этом разделе мы показываем внешние атрибуты деятельности застройщика ─ девелопера проекта." />
                      <p {...classes('text', 'description')} children="Место регистрации, налоговый долг, информативность сайта ЖК, награды застройщика и ЖК, открытость застройщика и мнение посетителей форума." />
                    </div>
                  </li>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="Отчёты получаются достаточно ёмкими ─ 50 страниц и более. Но это не должно вас смущать, ведь благодаря чёткой структуре, главным выводам, таблице баллов и человеческим комментариям экспертов, отчёты просты и понятны." />
                    </div>
                  </li>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="В отчёте отражены история и результаты профессиональной деятельности застройщика: введённые в эксплуатацию дома и долгострои. Мы показываем, как застройщик выполняет свои обещания по срокам сдачи ЖК в эксплуатацию." />
                    </div>
                  </li>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="Пункты, на которые следует обратить особое внимание, отражены в главных выводах отчёта и подсвечены красным в сводной таблице баллов. Детальный отчёт является юридическим документом, который фиксирует всю ситуацию по ЖК на момент оценки, всех участников и все документы, имеющие отношение к ЖК." />
                    </div>
                  </li>
                </ul>
              </Trans>
              <Trans lang="ua">
                <ul {...classes('list')}>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="У цьому розділі ми показуємо зовнішні атрибути діяльності забудовника ─ девелопера проєкту." />
                      <p {...classes('text', 'description')} children="Місце реєстрації, податковий борг, інформативність сайту ЖК, нагороди забудовника і ЖК, відкритість забудовника і думка відвідувачів форуму." />
                    </div>
                  </li>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="Звіти виходять досить об’ємними ─ 50 сторінок і більше. Але це не повинно вас бентежити, адже завдяки чіткій структурі, головним висновкам, таблиці балів і зрозумілим коментарям експертів, звіти дуже прості для сприйняття." />
                    </div>
                  </li>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="У звіті відображені історія і результати професійної діяльності забудовника: введені в експлуатацію будинки і довгобуди. Ми показуємо, як забудовник виконує свої обіцянки щодо термінів здачі ЖК в експлуатацію." />
                    </div>
                  </li>
                  <li {...classes('listItem')}>
                    <div {...classes('description', 'separatorLeft')}>
                      <p {...classes('text', 'description')} children="Пункти, на які слід звернути особливу увагу, відображені в головних висновках звіту та підсвічені червоним у зведеній таблиці балів. Детальний звіт є юридичним документом, який фіксує всю ситуацію відносно ЖК на момент оцінки, всіх учасників і всі документи, що мають відношення до ЖК." />
                    </div>
                  </li>
                </ul>
              </Trans>
            </Col>
            <Col {...classes('col', 'img')} allPr={0}>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={i18n('imgPDF5')} alt={i18n('reputationDeveloperAlt1')} loading="lazy" decoding="async" />
              </div>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={i18n('imgPDF6')} alt={i18n('reputationDeveloperAlt2')} loading="lazy" decoding="async" />
              </div>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={i18n('imgPDF7')} alt={i18n('reputationDeveloperAlt3')} loading="lazy" decoding="async" />
              </div>
              <div {...classes('imgContainer')}>
                <img {...classes('img')} src={i18n('imgPDF8')} alt={i18n('reputationDeveloperAlt4')} loading="lazy" decoding="async" />
              </div>
            </Col>
          </Row>
      </div>
    );
  }
}
